interface InactivityInput {
	hasCredentials: boolean
	deactivationReason: string | null
	scheduledDeactivationAt: string | null
}

export function deriveInactivityState(
	{ hasCredentials, deactivationReason, scheduledDeactivationAt }: InactivityInput,
) {
	return {
		showInactivityWarning: scheduledDeactivationAt !== null,
		wasDeactivatedForInactivity: !hasCredentials && deactivationReason === 'inactivity',
	}
}

export function formatInactivityDate(isoDate: string | null | undefined, language: string): string {
	if (!isoDate) { return '' }
	const date = new Date(isoDate)
	if (isNaN(date.getTime())) { return '' }
	return date.toLocaleDateString(language, { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' })
}
